import React from "react";
import "./styles.scss";

const LogoComponent = () => {
  return (
    // <div className="market-hut-box logo-main-wrapper">
    <div className="market-hut">
      <div className="d-flex flex-row">
        <span className="orange-text">Market</span>
        <span className="green-text">Hut</span>
      </div>
      <p className="tagline">“Inventory, Sales, and Staff—All in One Hut”</p>
    </div>
    // </div>
  );
};

export default LogoComponent;
